import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ResetPassword() {
  const { resetPassword } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setIsSubmitting(true);
    try {
      await resetPassword(email);
      setMessage('Check your inbox for a password reset link.');
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.message || 'Failed to send reset email');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ paddingTop: '4rem', display: 'flex', justifyContent: 'center' }}>
      <form onSubmit={handleSubmit} className="glass-card form-glass" style={{ padding: 24 }}>
        <h2 className="card-title" style={{ marginTop: 0 }}>Reset Password</h2>
  {error && <div className="form-row meta-text" style={{ color: '#ff6b6b', marginBottom: 8 }}>{error}</div>}
  {message && <div className="form-row meta-text" style={{ color: '#4caf50', marginBottom: 8 }}>{message}</div>}
        <label style={{ display: 'block', textAlign: 'left', marginBottom: 12 }}>
          <span className="form-label">Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="input-glass"
          />
        </label>
        <button disabled={isSubmitting} type="submit" className="btn-glass-primary btn-block">
          {isSubmitting ? 'Sending…' : 'Send reset link'}
        </button>
      </form>
    </div>
  );
}
